<template>
<body>
    <template v-if="!contact&&!guildPage">
        <div v-if="preFix&&promoleftTop1[0]" class="psd left_top1">
            <span @click="close('left_top1')">关闭X</span>
            <a :href="promoleftTop1[0].url" target="_blank">
                <img class="img lazy_brand" v-lazy="`${preFix}${promoleftTop1[0].media}`" />
                <!-- <img class="img lazy_brand" v-lazy="`${promoleftTop1[0].media}`" /> -->
            </a>
        </div>
        <div v-if="preFix&&promoleftTop2[0]" class="psd left_top2">
            <span @click="close('left_top2')">关闭X</span>
            <a :href="promoleftTop2[0].url" target="_blank">
                <img class="img lazy_brand" v-lazy="`${preFix}${promoleftTop2[0].media}`" />
                <!-- <img class="img lazy_brand" v-lazy="`${promoleftTop2[0].media}`" /> -->
            </a>
        </div>
        <div v-if="preFix&&promoleftTop3[0]" class="psd left_top3">
            <span @click="close('left_top3')">关闭X</span>
            <a :href="promoleftTop3[0].url" target="_blank">
                <img class="img lazy_brand" v-lazy="`${preFix}${promoleftTop3[0].media}`" />
                <!-- <img class="img lazy_brand" v-lazy="`${promoleftTop3[0].media}`" /> -->
            </a>
        </div>
        <div v-if="preFix&&promoleftTop4[0]" class="psd left_top4">
            <span @click="close('left_top4')">关闭X</span>
            <a :href="promoleftTop4[0].url" target="_blank">
                <img class="img lazy_brand" v-lazy="`${preFix}${promoleftTop4[0].media}`" />
                <!-- <img class="img lazy_brand" v-lazy="`${promoleftTop4[0].media}`" /> -->
            </a>
        </div>
        <div v-if="preFix&&promorightTop1[0]" class="psd right_top1">
            <span @click="close('right_top1')">关闭X</span>
            <a :href="promorightTop1[0].url" target="_blank">
                <img class="img lazy_brand" v-lazy="`${preFix}${promorightTop1[0].media}`" />
                <!-- <img class="img lazy_brand" v-lazy="`${promorightTop1[0].media}`" /> -->
            </a>
        </div>
        <div v-if="preFix&&promorightTop2[0]" class="psd right_top2">
            <span @click="close('right_top2')">关闭X</span>
            <a :href="promorightTop2[0].url" target="_blank">
                <img class="img lazy_brand" v-lazy="`${preFix}${promorightTop2[0].media}`" />
                <!-- <img class="img lazy_brand" v-lazy="`${promorightTop2[0].media}`" /> -->
            </a>
        </div>
        <div v-if="preFix&&promorightTop3[0]" class="psd right_top3">
            <span @click="close('right_top3')">关闭X</span>
            <a :href="promorightTop3[0].url" target="_blank">
                <img class="img lazy_brand" v-lazy="`${preFix}${promorightTop3[0].media}`" />
                <!-- <img class="img lazy_brand" v-lazy="`${promorightTop3[0].media}`" /> -->
            </a>
        </div>
        <div v-if="preFix&&promorightTop4[0]" class="psd right_top4">
            <span @click="close('right_top4')">关闭X</span>
            <a :href="promorightTop4[0].url" target="_blank">
                <img class="img lazy_brand" v-lazy="`${preFix}${promorightTop4[0].media}`" />
                <!-- <img class="img lazy_brand" v-lazy="`${promorightTop4[0].media}`" /> -->
            </a>
        </div>
    </template>
    <template v-if="isMobile">
        <WapHeader v-if="!guildPage" />
    </template>
    <template v-else>
        <Header v-if="!contact&&!guildPage" />
        <template v-if="promohead&&!contact&&!guildPage&&!isActPage">
            <div class="pad_top" v-for="(item,idx) in promohead" :key="idx">
                <a v-if="preFix&&item" class="peddle" :href="item.url" target="_blank">
                    <img class="img lazy_post" v-lazy="`${preFix}${item.media}`" />
                    <!-- <img class="img lazy_post" v-lazy="`${item.media}`" /> -->
                </a>
            </div>
        </template>
        <template  v-if="promotext&&!contact&&!guildPage&&!isActPage">
            <div class="pad_textBox" v-if="promotext">
                <div class="pad_text" v-for="(item,ix) in promotext" :key="ix">
                    <a :href="item.url" target="_blank">{{item.title}}</a>
                </div>
            </div>
        </template>
        <Menu v-if="!isActPage&&!contact&&!guildPage" />
    </template>
    <template v-if="mobileOn">
        <!-- <div v-if="ad&&promorBottom" class="banner flx_bottom">
            <span @click="close">关闭X</span>
            <template v-for="(item,index) in promorBottom">
                    <adPoster
                        v-if="index==broadIndex"
                        :key="index"
                        :viewData="item"
                        :preFix="preFix"
                        class="top_only"
                    />
            </template>
        </div> -->
    </template>
    <router-view></router-view>
    <template v-if="isMobile">
        <div v-if="!guildPage" class="footer">{{scrollFetching?'加载中':'环亚无码'}}</div>
    </template>
    <template v-else>
        <Footer v-if="!guildPage" />
    </template>
</body>
</template>
<script>
import { mapState } from "vuex";
// import adPoster from "./element/adPoster";
import "../css/mobile/home.scss";
import ADSKEYS from '../tools/adKeys'
export default {
    components: {
        Header: () => import("./polymer/Header"),
        Menu: () => import("./polymer/Menu"),
        Footer: () => import("./polymer/Footer"),
        WapHeader: () => import("./polymer/WapHeader"),
        // adPoster
    },
    data: function() {
        return {
            isMobile: this.vueGloble.isMobile,
            broadIndex: 0,
            ad: true,
            mobileOn: false
        };
    },
    computed: {
        ...mapState([
            "pageLoad",
            "scrollFetching",
            "globle",
            "promotion",
            "homePage"
        ]),
        preFix() {
            return (
                this.globle && this.globle.list && this.globle.list.site_imgaddr
            );
        },
        promohead() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1002]] && this.promotion[ADSKEYS[1002]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1001]] && this.promotion[ADSKEYS[1001]].ads) || [];
            }
        },
        promotext() {
            return this.promotion.text_ad || '';
        },
        promoleftTop1() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1011]] && this.promotion[ADSKEYS[1011]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1003]] && this.promotion[ADSKEYS[1003]].ads) || [];
            }
            
        },
        promoleftTop2() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1012]] && this.promotion[ADSKEYS[1012]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1004]] && this.promotion[ADSKEYS[1004]].ads) || [];
            }
        },
        promoleftTop3() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1013]] && this.promotion[ADSKEYS[1013]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1005]] && this.promotion[ADSKEYS[1005]].ads) || [];
            }
        },
        promoleftTop4() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1014]] && this.promotion[ADSKEYS[1014]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1006]] && this.promotion[ADSKEYS[1006]].ads) || [];
            }
        },
        promorightTop1() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1015]] && this.promotion[ADSKEYS[1015]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1007]] && this.promotion[ADSKEYS[1007]].ads) || [];
            }
        },
        promorightTop2() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1016]] && this.promotion[ADSKEYS[1016]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1008]] && this.promotion[ADSKEYS[1008]].ads) || [];
            }
        },
        promorightTop3() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1017]] && this.promotion[ADSKEYS[1017]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1009]] && this.promotion[ADSKEYS[1009]].ads) || [];
            }
        },
        promorightTop4() {
            if(this.isMobile){
                return (this.promotion[ADSKEYS[1018]] && this.promotion[ADSKEYS[1018]].ads) || [];
            }else{
                return (this.promotion[ADSKEYS[1010]] && this.promotion[ADSKEYS[1010]].ads) || [];
            }
        },
        isActPage() {
            return this.$route.path == "/intro";
        },
        contact() {
            return this.$route.path == "/contact";
        },
        guildPage() {
            return this.$route.path == "/";
        },
        promorBottom() {
            // console.log(this.promotion)
            // debugger;
            let data = (this.promotion['24'] && this.promotion['24'].ads) || [];
            if (data.length > 8) {
                data.length = 8;
            }
            // return data;
            return data;
        }
    },
    watch: {
        $route(newData) {
            if (
                this.globle &&
                this.globle.list &&
                this.globle.list.site_tongji
            ) {
                document.getElementById("statitic").remove();
                var hm = document.createElement("script");
                hm.id = "statitic";
                hm.src = this.globle.list.site_tongji;
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(hm, s);
                window._hmt.push(["_trackPageview", `/#${newData.fullPath}`]);
            }
        },
        broadIndex(newData) {
            setTimeout(() => {
				if(this.promorBottom.length>2){
					if (newData < this.promorBottom.length - 1) {
						this.broadIndex++;
					} else {
						this.broadIndex = 0;
					}
				}
            }, 3000);
        }
    },
    methods: {
        close(id) {
            if (id === "left_top1") {
                document.getElementsByClassName("left_top1")[0].style.display =
                    "none";
            } else if (id === "left_top2") {
                document.getElementsByClassName(
                    "left_top2"
                )[0].style.display = "none";
            } else if (id === "left_top3") {
                document.getElementsByClassName("left_top3")[0].style.display =
                    "none";
            } else if (id === "left_top4") {
                document.getElementsByClassName(
                    "left_top4"
                )[0].style.display = "none";
            } else if (id === "right_top1") {
                document.getElementsByClassName(
                    "right_top1"
                )[0].style.display = "none";
            } else if (id === "right_top2") {
                document.getElementsByClassName(
                    "right_top2"
                )[0].style.display = "none";
            } else if (id === "right_top3") {
                document.getElementsByClassName(
                    "right_top3"
                )[0].style.display = "none";
            } else if (id === "right_top4") {
                document.getElementsByClassName(
                    "right_top4"
                )[0].style.display = "none";
            } 
            else {
                this.ad = !this.ad;
            }
        }
    },
    created() {
        this.$store.dispatch("fetchGloble");
        this.$store.dispatch("fetchPromotion");
        let ua = navigator.userAgent.toLocaleLowerCase();
        this.mobileOn = ua.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
    },
    mounted() {
        if (this.promorBottom.length > 1) {
            this.broadIndex++;
        }
        document.documentElement.scrollTop = 0;
    }
};
</script>
<style lang="scss" scoped>
.slide-enter-active {
    transform: translateX(100%);
    transition: all 0.3s ease-in-out;
}
.slide-enter-to {
    transform: translateX(0);
}
.slide-leave-active {
    transition: all 0.3s ease-in-out;
    transform: translateX(0);
}
.slide-leave-to {
    transform: translateX(-100%);
}
</style>

